import { render, staticRenderFns } from "./background.vue?vue&type=template&id=51d0e3ad&scoped=true"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0e3ad",
  null
  
)

export default component.exports